var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BlogHero from '@images/marketing/Blog-Hero.jpg';
import Loader from '@marketing/components/global/misc/Loader';
import BlogTopic, { LoadMoreTopics } from '@marketing/components/global/misc/blog/Topic';
import { SingleImageHeroSection } from '@marketing/components/sections/heroes/HeroSection/HeroSection';
import Listing from '@marketing/components/sections/non_product/Blog/Listing';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, useRouteLoaderData, useSearchParams } from 'react-router';
import { PAGE_TYPE } from './types';
var BUTTER_PAGE_SIZE = 6;
var BUTTER_CATEGORY_PAGE_SIZE = 5;
var Articles = function () {
    var categorySlug = useParams().categorySlug;
    var _a = useSearchParams(), searchParams = _a[0], setURLSearchParams = _a[1];
    var navigate = useNavigate();
    var Butter = useRouteLoaderData('root').Butter;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(0), pageCount = _c[0], setPageCount = _c[1];
    var _d = useState([]), categories = _d[0], setCategories = _d[1];
    var _e = useState(BUTTER_CATEGORY_PAGE_SIZE), categoryCount = _e[0], setCategoryCount = _e[1];
    var _f = useState([]), articles = _f[0], setArticles = _f[1];
    var _g = useState([]), errors = _g[0], setErrors = _g[1];
    var pageNumber = +searchParams.get('page') || 1;
    var fetchArticles = function (categoryApiSlug, page) {
        if (categoryApiSlug === void 0) { categoryApiSlug = null; }
        if (page === void 0) { page = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var pageParams;
            return __generator(this, function (_a) {
                // PageListParams doesn't support fields that aren't flat, i.e. article categories, so we need to hack this in.
                setIsLoading(true);
                pageParams = {
                    alt_media_text: 1,
                    page: page || pageNumber,
                    page_size: BUTTER_PAGE_SIZE,
                };
                if (categoryApiSlug) {
                    pageParams['fields.article_categories.api_slug'] = categoryApiSlug;
                }
                return [2 /*return*/, Butter.page
                        .list(PAGE_TYPE, pageParams)
                        .then(function (response) {
                        var pageCount = 0;
                        if (response.data) {
                            var newArticles = void 0;
                            pageCount = Math.ceil(response.data.meta.count / BUTTER_PAGE_SIZE);
                            if (articles.length === 0 || pageNumber === 1) {
                                newArticles = Array.from(Array(pageCount + 1), function () { return []; });
                                newArticles[pageNumber] = response.data.data;
                            }
                            else {
                                newArticles = __spreadArray([], articles, true);
                                newArticles[pageNumber] = response.data.data;
                            }
                            setArticles(newArticles);
                        }
                        setPageCount(pageCount);
                    })
                        .catch(function (error) {
                        console.error('Error fetching posts:', error);
                        setErrors(['Error fetching posts. Please try again later.']);
                    })
                        .finally(function () { return setIsLoading(false); })];
            });
        });
    };
    var fetchCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Butter.content
                    .retrieve(['article_category'])
                    .then(function (response) {
                    if (response.data) {
                        setCategories(__spreadArray(__spreadArray([], categories, true), response.data.data.article_category, true));
                    }
                })
                    .catch(function (error) {
                    console.error('Error fetching categories:', error);
                })];
        });
    }); };
    var changeCategory = function (e, categoryApiSlug) {
        if (categoryApiSlug === void 0) { categoryApiSlug = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                e.preventDefault();
                options = { preventScrollReset: true, viewTransition: true };
                // Remove the category when unchecked
                if (categoryApiSlug === categorySlug) {
                    navigate("/learn", options);
                    fetchArticles();
                }
                else {
                    navigate("/learn/category/".concat(categoryApiSlug), options);
                    fetchArticles(categoryApiSlug);
                }
                return [2 /*return*/];
            });
        });
    };
    var changePage = function (pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setURLSearchParams("?page=".concat(pageNumber));
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (categorySlug) {
            fetchArticles(categorySlug);
        }
        else {
            fetchArticles();
        }
    }, [pageNumber]);
    useEffect(function () {
        fetchCategories();
    }, []);
    return (_jsxs("div", __assign({ className: "header-lining bg-surface-beige" }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "The Dog Parent Dispatch | Nom Nom Blog" }), _jsx("meta", { name: "description", content: "Explore our blog for the latest articles, tips, and stories about dog parenting." }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/learn" })] }), errors.length > 0 && (_jsx("div", __assign({ className: "bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4", role: "alert" }, { children: _jsx("ul", { children: errors.map(function (error, index) { return (_jsx("li", { children: error }, index)); }) }) }))), _jsxs("main", __assign({ id: "main-content" }, { children: [_jsx(SingleImageHeroSection, { content: {
                            heroImage: {
                                src: BlogHero,
                                alt: 'A happy dog with its ears up, licking its lips',
                            },
                            headline: 'The Dog Parent Dispatch',
                            subhead: "How do I deal with separation anxiety? Do different dog breeds\n              have different personalities? What in the world are zoomies? We're here\n              for dog parents during every part of their day, with expert advice on\n              the topics they obsess about.\n            ",
                        }, backgroundColor: "beige", headingLevel: "h1", hideCTA: true }), categories.length > 0 && (_jsxs("div", __assign({ className: "flex flex-col justify-center items-center py-xl-m md:px-lg-gutter xl:px-3xl-gutter bg-surface-beige" }, { children: [_jsx("h2", __assign({ className: "font-sans font-medium text-lg mb-4" }, { children: "Filter by topic" })), _jsx("form", __assign({ onSubmit: function (e) { return e.preventDefault(); } }, { children: _jsxs("fieldset", __assign({ className: "flex flex-wrap items-center justify-center gap-2xs-button mx-4" }, { children: [_jsx("legend", __assign({ className: "sr-only" }, { children: "Select a topic to automatically filter the articles" })), categories.slice(0, categoryCount).map(function (category) { return (_jsx(BlogTopic, { topic: category.category_name, isLoading: isLoading, isSelected: categorySlug === category.api_slug, onClick: function (e) { return changeCategory(e, category.api_slug); }, onChange: function (e) {
                                                return changeCategory(e, category.api_slug);
                                            } }, category.api_slug)); }), categoryCount < categories.length && (_jsx(LoadMoreTopics, { onClick: function () {
                                                return setCategoryCount(function (prevCount) { return prevCount + BUTTER_CATEGORY_PAGE_SIZE; });
                                            } }))] })) }))] }))), !isLoading && articles.length > 0 && articles[pageNumber].length > 0 ? (_jsx(Listing, { articles: articles[pageNumber], pageCount: pageCount, currentPageIndex: pageNumber, onPageChange: changePage })) : (_jsx("div", __assign({ className: "flex justify-center items-center h-64 bg-beige-100" }, { children: _jsx(Loader, {}) })))] })), _jsx(Newsletter, { flip: true })] })));
};
export default Articles;
